import styled from '@emotion/styled';
import { breakpoint, spacing } from '#themes/stena-recycling';

export const QuickRangeWrapper = styled.div`
  margin-right: ${spacing.small};
  padding-right: ${spacing.small};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: ${spacing.xxsmall};

  @media (max-width: ${breakpoint.medium}px) {
    border-right: none;
    border-top: 1px solid #d6d7d9;
    padding: ${spacing.xmsmall} 0 0;
    margin: ${spacing.xmsmall} 0 0;
    align-items: center;
  }
`;

export const PeriodLabelContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.xxsmall};

  svg {
    flex-shrink: 0;
    transform: translateY(0.5px);
  }
`;
